@let loading = loading$ | async;
@let rows = rows$ | async;
@let columns = columns$ | async;
@let modes = aggregationModes$ | async;
@let aggregationMode = aggregationMode$ | async;
@let warning = warning$ | async;
@let header = header$ | async;
@let showFooter = showFooter$ | async;

<div class="mcm-ranking-container">
  <mcm-ranking-header
    [header]="header"
    (closeModal)="close()" />
  <div class="mcm-ranking-container__selector">
    <app-segmented-control
      class="mcm-ranking-container__segmented-control"
      [options]="modes"
      [value]="overrideAggregationMode || aggregationMode?.id"
      [modifiers]="segmentModifiers"
      (onChange)="onModeChange($event)" />
  </div>
  @if (loading) {
    <div class="mcm-ranking-container__loader">
      <mcm-loader [loading]="true" />
    </div>
  } @else if (rows?.length >= 2) {
    <div class="mcm-ranking-container__content">
      <mcm-table
        headerHeight="31px"
        rowHeight="40px"
        [excludeFromSortingFn]="excludeFromSortFn"
        [drawRowHolder]="true"
        [headerTpl]="headerTpl"
        [rows]="rows"
        [rowStyles]="rowStyles"
        [columns]="columns"
        [cellTpl]="cellTpl"
        [sortable]="true"
        [trackByFn]="trackByFn.bind(this)">
        <ng-template
          #headerTpl
          let-column="column"
          let-isFirstColumn="isFirstColumn">
          <div
            class="mcm-ranking-container__content-header"
            [class.first-column]="isFirstColumn">
            {{ column.label | translate }}
          </div>
        </ng-template>
        <ng-template
          #cellTpl
          let-row="row"
          let-column="column">
          @switch (column.key) {
            @case ('name') {
              <img
                loading="lazy"
                class="mcm-ranking-container__content-image rounded"
                [srcUrl]="row?.photoUrl"
                [mcuiDefaultImage]="row.imagePlaceholder"
                alt="" />
              <div
                class="mcm-ranking-container__content-name"
                [class.low-involvement]="row.lowInvolvement">
                {{ row[column.key] | translate | invalidValueHandler }}
              </div>
            }
            @case ('teamPhotoUrl') {
              <div
                class="mcm-ranking-container__content-image centered"
                [class.team]="!row?.isCompetition">
                @if (!row?.isCompetition) {
                  <img
                    loading="lazy"
                    class="mcm-ranking-container__content-image"
                    [srcUrl]="row?.teamPhotoUrl"
                    [mcuiDefaultImage]="row.teamPlaceholder"
                    alt="" />
                }
              </div>
            }
            @default {
              <span class="mcm-ranking-container__content-value">
                {{ row[column.key] | translate | invalidValueHandler }}
              </span>
            }
          }
        </ng-template>
      </mcm-table>
    </div>
    @if (showFooter) {
      <div class="mcm-ranking-container__footer">* {{ 'MTR_RANKING_FOOTER' | translate }}</div>
    }
  } @else {
    @let param = warning.param ? { aggregation: (warning.param | translate) } : '';
    <div class="mcm-ranking-container__warning">
      <ion-icon
        name="information-circle-outline"
        size="large"
        color="primary" />
      <p>
        {{ warning.param ? (warning.text | translate: param) : (warning.text | translate) }}
      </p>
    </div>
  }
</div>
